import { ReactNode, useContext } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { AuthContext } from "./authContext";
import SignInPage from "@/app/signin/page";
import { isValidToken } from "./utils";
import ResetPasswordForm from "@/app/auth/(forgot-password)/forgot-password-1/forget-password-form";
import ForgetPasswordPage from "@/app/auth/(forgot-password)/forgot-password-1/page";

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { authenticated, setAuthenticated } = useContext(AuthContext);

  const { pathname } = useLocation();

  if (!isValidToken()) {
    setAuthenticated(false);
  } else {
    setAuthenticated(true);
  }

  if (!authenticated) {
    if (pathname.toLocaleLowerCase().includes("forgot-password-1")) {
      return <ForgetPasswordPage />;
    }
    return <SignInPage />;
  } else {
    if (pathname.toLocaleLowerCase().includes("login")) {
      return <Navigate to={"/"} replace />;
    }
  }

  return <>{children}</>;
}
